<div>
  The URL you navigated to doesn't actually go anywhere.
</div>

<a
  class="button yellow"
  [routerLink]="'/'"
>
  Go to Apps
</a>
